import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import { LoginContextProvider } from './Contexts/login-context';
import store from './Components/Redux/store';
import { Provider } from 'react-redux';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement  
);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <LoginContextProvider>
        <App />    
      </LoginContextProvider>
    </BrowserRouter>  
  </Provider>
);

reportWebVitals();
